<template>
  <GmapMap
    :center="defaultMapCenter"
    :zoom="4"
    ref="map"
    style="width: 100%; height: 100%">


    <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :icon="m.icon"
      :position="m.position"
      :clickable="true"
      :animation="animations.DROP"
      @click="center=m.position"
    />
  </GmapMap>
</template>

<!--
<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyASjHBanL0YC855XEqSvQ31nrjmx2R8S-g&callback=initMap">
</script>
-->
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { sortBy, last } from 'lodash-es'

export default {
  name: 'RouteMap',

  props: {
    companyJobKey: {
      type: String,
      required: true
    },
    jobPoints: {
      type: Array
    }
  },

  created() {
    if (!this.executionLog.length) {
      this.fetchExecutionLogByKey(this.companyJobKey)
    }
  },

  mounted() {
    this.$refs.map.$mapPromise.then((map) => {
      // Google Maps is loaded in via the `vue2-google-maps` plugin
      const directionsService = new google.maps.DirectionsService()
      const directionsDisplay = new google.maps.DirectionsRenderer()

      directionsDisplay.setMap(map)
      this.calculateAndDisplayRoute(directionsService, directionsDisplay)
    })
  },

  computed: {
    ...mapGetters('companyJobs', ['lastGpsEntry', 'listAsMap']),
    ...mapState('companyJobs', ['executionLogs']),

    /**
     * Array of GPS coordinates sorted by the earliest pickup time
     * @returns {Array}
     */
    sortedGpsPoints() {
      return sortBy(this.jobPoints, 'companyJobPointDateEarliest').map((jobPoint) => ({
        lat: jobPoint.address.companyRolodexJobLocationGpsLatitudeCoordinate || 0,
        lng: jobPoint.address.companyRolodexJobLocationGpsLongitudeCoordinate || 0
      }))
    },

    /**
     *  GPS coordinates of the first pickup location
     * @returns {Object}
     */
    firstPoint() {
      return this.sortedGpsPoints[0]
    },

    /**
     *  GPS coordinates of the lat dropoff location
     * @returns {Object}
     */
    lastPoint() {
      return last(this.sortedGpsPoints)
    },

    /**
     * Array of all in-between stops represented as Google Maps "waypoint" objects.
     * Basically the list of jobPoints with out the first and last stop
     * @returns {Array}
     */
    wayPoints() {
      const itemCount = this.sortedGpsPoints.length - 1
      return this.sortedGpsPoints.slice(1, itemCount).map((point) => ({
        location: point
        // stopover: true
      }))
    },

    executionLog() {
      return this.executionLogs[this.companyJobKey] || []
    },

    previousGpsLocations() {
      let lastPositions = []
      const gpsEntries = this.executionLog.filter((log) => log.companyJobExecutionLogEntryKey === 'gps_location')

      if (gpsEntries.length) {
        lastPositions = gpsEntries.map((log) => {
          const [lat, lng] = log.companyJobExecutionLogEntryValue.split(',')
          return {
            lat: Number.parseFloat(lat),
            lng: Number.parseFloat(lng)
          }
        })
      }

      return lastPositions
    },

    markers() {
      const mostRecentLocation = { position: this.lastGpsEntry(this.companyJobKey), icon: '/map-marker-blue-dot.png' }
      const pastLocations = this.previousGpsLocations.map((position) => ({
        position: position,
        icon: '/map-marker-gray-dot.png'
      }))
      return [mostRecentLocation, ...pastLocations]
    }
  },

  data() {
    return {
      // Lebanon, Kansas - the middle of the US
      // ref: http://www.kansastravel.org/geographicalcenter.htm
      defaultMapCenter: { lat: 39.809797, lng: -98.55518 },
      animations: window.google.maps.Animation
    }
  },

  methods: {
    ...mapActions('companyJobs', ['fetchExecutionLogByKey']),

    calculateAndDisplayRoute(directionsService, directionsDisplay) {
      directionsService.route(
        {
          origin: this.firstPoint,
          destination: this.lastPoint,
          waypoints: this.wayPoints,
          travelMode: 'DRIVING'
        },
        function(response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response)
          } else {
            // window.alert('Directions request failed due to ' + status)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
</style>
